import { CreateFlowcodeFormField } from '../CreateFlowcodeForm.types'
import { FileDestinations, LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'
import { GetLandingPageDestinationType } from '@app/code/src/types/flowcode.types'

export const hasLandingPageDestination = ({
  type,
  values
}: GetLandingPageDestinationType): boolean => {
  if (type in FileDestinations) return Boolean(values.file)
  if (type === LandingPageDestination.SMS) return Boolean(values.sms.phoneNumber)
  return Boolean(values.link)
}

export const getFormField = (
  selectedDestination: LandingPageDestination
):
  | CreateFlowcodeFormField.File
  | CreateFlowcodeFormField.SMSPhoneNumber
  | CreateFlowcodeFormField.LINK => {
  if (selectedDestination in FileDestinations) return CreateFlowcodeFormField.File
  if (selectedDestination === LandingPageDestination.SMS)
    return CreateFlowcodeFormField.SMSPhoneNumber
  return CreateFlowcodeFormField.LINK
}
